import {inject, Injectable, signal} from '@angular/core';
import {TelegramLoadFileService} from "./telegram-load-file.service";
import {SetBloggersImageParams} from "../types/telegram-bloggers.types";
import {defaultIcon} from "../configs/telegram-page-config";

@Injectable({
  providedIn: 'root'
})
export class TelegramBloggersService {
  private telegramLoadFileService: TelegramLoadFileService = inject(TelegramLoadFileService);
  private _bloggersImage = signal<Record<number, string>>({});
  private bloggersImage = this._bloggersImage.asReadonly();

  public async setBloggersImage({ chat, accountId }: SetBloggersImageParams): Promise<void> {
    if (this._bloggersImage().hasOwnProperty(chat.id)) { return; }

    const url = await this.telegramLoadFileService.loadImage({
      remoteId: chat.profilePhotoUrl,
      accountId: accountId
    });

    this._bloggersImage.update(current => ({
      ...current,
      [chat.id]: url
    }));
  }

  public getBloggerImage(id: number): string {
    return this.bloggersImage()[id] || defaultIcon
  }
}
